export default __webpack_public_path__ + "static/media/ic_arrows_down_48px.0588adae.svg";